import { useAuth } from '../../hooks/useAuth'
import { EAuthSettingsSection } from '../../models/auth.model'
import { UserSettingsFlowType } from '@ory/elements'

const PASSWORD_AUTH_METHOD = 'password'

export const useGetSettingsSections = () => {
  const { session } = useAuth()

  const hasPasswordAuthMethod = !!session?.authentication_methods?.find((mtd) => mtd.method === PASSWORD_AUTH_METHOD)
  const sections = [EAuthSettingsSection.TOTP, EAuthSettingsSection.WEB_AUTHN, EAuthSettingsSection.LOOKUP_SECRET]

  if (hasPasswordAuthMethod) {
    sections.unshift(EAuthSettingsSection.PASSWORD)
  }

  return sections as UserSettingsFlowType[]
}
